const BACK_OFFICE_USER_SYSTEMS_TABLE = {
  columns: [
    {
      label: 'admin_info.system_name_header',
      field: 'name',
      translate: false,
      ordering: true
    },
    {
      label: 'admin_info.status_header',
      field: 'userStatus',
      translate: true,
      getValue: (raw) => {
        return 'admin_system_status.' + raw.userStatus;
      },
      ordering: true
    },
    {
      label: 'admin_info.change_status_header',
      field: 'changeStatus',
      ordering: false,
      getStyle(raw) {
        return {float: 'right'};
      },
      preventClick: true
    }
  ]
}

export default BACK_OFFICE_USER_SYSTEMS_TABLE;
